import React, { useState, useEffect } from 'react';
import '../assets/ManageLetters.css';

const LetterForm = () => {
  const [letterFor, setLetterFor] = useState('Customer');
  const [letterType, setLetterType] = useState('Welcome Letter');
  const [letterContent, setLetterContent] = useState('Lets create a great letter!');
  const [letters, setLetters] = useState([]);

  useEffect(() => {
    if (window.ClassicEditor) {
      window.ClassicEditor.create(document.querySelector('#letterContent')).then(editor => {
        window.editorInstance = editor;
        editor.setData(letterContent);
      });
    }
  }, []);

  const resetForm = () => {
    setLetterFor('Customer');
    setLetterType('Welcome Letter');
    if (window.editorInstance) {
      window.editorInstance.setData('Lets create a great letter!');
    }
  };

  const saveLetter = () => {
    const newLetter = {
      letterFor,
      letterType
    };

    setLetters(prevLetters => [...prevLetters, newLetter]);
    alert('Letter saved successfully.');
  };

  return (
    <div>
      <div className="letter-section">
        <div className="letter-header">
          <i className="fas fa-envelope"></i>
          <h2>Create Letter</h2>
        </div>
        <form className="letter-form" onSubmit={(e) => e.preventDefault()}>
          <div>
            <label htmlFor="letterFor">Letter For:</label>
            <select id="letterFor" value={letterFor} onChange={(e) => setLetterFor(e.target.value)}>
              <option>Customer</option>
              <option>Admin</option>
              <option>Agent</option>
            </select>
          </div>
          <div>
            <label htmlFor="letterType">Letter Type:</label>
            <select id="letterType" value={letterType} onChange={(e) => setLetterType(e.target.value)}>
              <option>Welcome Letter</option>
              <option>Appointment Letter</option>
              <option>Joining Letter</option>
            </select>
          </div>
        </form>

        <div className="letter-editor">
          <label htmlFor="letterContent">Letter Content:</label>
          <textarea id="letterContent" defaultValue={letterContent}></textarea>
        </div>

        <div className="letter-actions">
          <button onClick={resetForm} className="btn reset">
            <i className="fas fa-times"></i> Reset
          </button>
          <button onClick={saveLetter} className="btn save">
            <i className="fas fa-save"></i> Save Letter
          </button>
        </div>
      </div>

      <div className="letter-section">
        <div className="letter-header">
          <i className="fas fa-table"></i>
          <h2>Letter Report</h2>
        </div>
        <div className="letter-actions">
          <button className="btn save"><i className="fas fa-print"></i> Print</button>
          <button className="btn save"><i className="fas fa-file-pdf"></i> PDF</button>
          <button className="btn save"><i className="fas fa-file-excel"></i> Excel</button>
        </div>
        <div className="letter-table-container">
          <table className="letter-table">
            <thead>
              <tr>
                <th>#</th>
                <th>Letter For</th>
                <th>Letter Type</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {letters.map((letter, index) => (
                <tr key={index}>
                  <td>{index + 1}</td>
                  <td>{letter.letterFor}</td>
                  <td>{letter.letterType}</td>
                  <td>
                    <button className="btn save">
                      <i className="fas fa-edit"></i> Edit
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default LetterForm;
 